const encode = value => encodeURIComponent(value || '')

export const BasemapProviders = Object.freeze({
  openStreetMap: {
    id: 'openstreetmap',
    name: 'OpenStreetMap',
    type: 'xyz',
    url: 'https://tile.openstreetmap.org/{z}/{x}/{y}.png',
    attribution: '\u00A9 OpenStreetMap contributors'
  }
})

export function wmsTileUrl({ url, layers, format = 'image/png' }) {
  const separator = url.includes('?') ? '&' : '?'
  return `${url}${separator}service=WMS&request=GetMap&version=1.3.0&layers=${encode(layers)}&styles=&format=${encode(format)}&transparent=true&width=256&height=256&crs=EPSG%3A3857&bbox={bbox-epsg-3857}`
}

export class DataSourceRegistry {
  constructor() {
    this.providers = new Map(Object.values(BasemapProviders).map(provider => [provider.id, provider]))
    this.sourceTypes = new Map([
      ['xyz', { id: 'xyz', name: 'XYZ tiles' }],
      ['wms', { id: 'wms', name: 'WMS' }],
      ['wmts', { id: 'wmts', name: 'WMTS tile template' }]
    ])
  }

  registerProvider(provider) {
    if (!provider || !provider.id || !provider.url) throw new Error('A basemap provider needs an id and tile URL.')
    this.providers.set(provider.id, provider)
  }

  registerSourceType(sourceType) {
    if (!sourceType || !sourceType.id) throw new Error('A source type needs an id.')
    this.sourceTypes.set(sourceType.id, sourceType)
  }

  listProviders() { return [...this.providers.values()] }
  listSourceTypes() { return [...this.sourceTypes.values()] }
}

export const dataSources = new DataSourceRegistry()
